// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared tag chip — one visual across every surface that renders a
   document tag (dashboard queue, upload inbox, document list). Before
   this file each surface had its own .queue-chip / .upload-doc-tag /
   .dm-doc-tag with slightly different padding, radius, and font, so
   the same underlying "document tag" looked subtly different across
   the app.

   Class family:
   .tag-chip                     base — inline-flex pill, 999px radius.
   .tag-chip--applied            applied/committed tag. Uses inline
                                 style for background/color/borderColor
                                 driven by the tag row's own color:
                                   background: \`\${color}20\`   (12.5% tint)
                                   borderColor: \`\${color}40\`  (25% tint)
                                   color:       \`\${color}\`
                                 The class itself only owns shape.
   .tag-chip--suggested          AI-suggested tag pending accept/dismiss.
                                 Dashed slate border, transparent bg.
   .tag-chip--proposed           AI-proposed new tag (creates a tag on
                                 accept). Dashed purple border,
                                 transparent bg.
   .tag-chip__prefix             Uppercase "NEW:" label inside a
                                 proposed chip.
   .tag-chip__remove             Small × for removing an applied tag.
   .tag-chip__btn                Circular accept/dismiss action button
                                 for suggested/proposed chips.
   .tag-chip__btn--accept        Moss-green tinted variant.
   .tag-chip__btn--dismiss       Error-red tinted variant.

   Mobile: the action circles bump to var(--touch-target-min, 44px)
   below 767px so finger taps reliably hit their target — previously
   this rule lived in QueueWidget.css and only fired on the queue. */

.tag-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 5px 3px 10px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: 1.4;
}

/* .tag-chip--applied: shape only. The React caller supplies inline
   \`background\`, \`color\`, and \`borderColor\` derived from the tag's own
   color so each tag reads as its own thing. */
.tag-chip--applied {
  border-style: solid;
}

.tag-chip--suggested {
  background: transparent;
  color: #64748b;
  border-style: dashed;
  border-color: #94a3b8;
}

.tag-chip--proposed {
  background: transparent;
  color: #7c3aed;
  border-style: dashed;
  border-color: #a78bfa;
}

.tag-chip__prefix {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.7;
}

.tag-chip__remove {
  border: none;
  background: transparent;
  color: inherit;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  margin: 0 -2px 0 1px;
  opacity: 0.5;
  line-height: 1;
}

.tag-chip__remove:hover {
  opacity: 1;
}

.tag-chip__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  cursor: pointer;
  line-height: 1;
  border-radius: 50%;
  transition:
    background 0.15s ease,
    box-shadow 0.12s ease;
}

.tag-chip__btn svg {
  display: block;
}

.tag-chip__btn:focus-visible {
  outline: 2px solid var(--color-info, #5c7cba);
  outline-offset: 2px;
}

.tag-chip__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.tag-chip__btn--accept {
  background: rgba(76, 106, 88, 0.15);
  color: var(--color-secondary, #4c6a58);
}

.tag-chip__btn--accept:hover:not(:disabled) {
  background: rgba(76, 106, 88, 0.28);
}

.tag-chip__btn--dismiss {
  background: rgba(212, 76, 76, 0.12);
  color: var(--color-error, #d44c4c);
}

.tag-chip__btn--dismiss:hover:not(:disabled) {
  background: rgba(212, 76, 76, 0.22);
}

/* Mobile: the action circles get a proper touch target. 24px is fine
   for a mouse pointer, well below the 44px minimum for a finger tap,
   and accept/dismiss sit right next to each other so mis-taps happen
   a lot. The chip padding + font size also nudge up so the wider
   buttons don't push the label out. */
@media (max-width: 767px) {
  .tag-chip {
    padding: 4px 6px 4px 12px;
    gap: 8px;
    font-size: 0.9rem;
  }
  .tag-chip__btn {
    width: var(--touch-target-min, 44px);
    height: var(--touch-target-min, 44px);
  }
  .tag-chip__btn svg {
    width: 18px;
    height: 18px;
  }
  /* Applied-tag remove × was tiny — users on mobile routinely
     mis-tap it. Give it a real touch target. */
  .tag-chip__remove {
    min-width: 28px;
    min-height: 28px;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/tag-chip.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;oEA+BoE;;AAEpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;8CAE8C;AAC9C;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB;;yBAEuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;sCAIsC;AACtC;EACE;IACE,yBAAyB;IACzB,QAAQ;IACR,iBAAiB;EACnB;EACA;IACE,oCAAoC;IACpC,qCAAqC;EACvC;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;+CAC6C;EAC7C;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["/* Shared tag chip — one visual across every surface that renders a\n   document tag (dashboard queue, upload inbox, document list). Before\n   this file each surface had its own .queue-chip / .upload-doc-tag /\n   .dm-doc-tag with slightly different padding, radius, and font, so\n   the same underlying \"document tag\" looked subtly different across\n   the app.\n\n   Class family:\n   .tag-chip                     base — inline-flex pill, 999px radius.\n   .tag-chip--applied            applied/committed tag. Uses inline\n                                 style for background/color/borderColor\n                                 driven by the tag row's own color:\n                                   background: `${color}20`   (12.5% tint)\n                                   borderColor: `${color}40`  (25% tint)\n                                   color:       `${color}`\n                                 The class itself only owns shape.\n   .tag-chip--suggested          AI-suggested tag pending accept/dismiss.\n                                 Dashed slate border, transparent bg.\n   .tag-chip--proposed           AI-proposed new tag (creates a tag on\n                                 accept). Dashed purple border,\n                                 transparent bg.\n   .tag-chip__prefix             Uppercase \"NEW:\" label inside a\n                                 proposed chip.\n   .tag-chip__remove             Small × for removing an applied tag.\n   .tag-chip__btn                Circular accept/dismiss action button\n                                 for suggested/proposed chips.\n   .tag-chip__btn--accept        Moss-green tinted variant.\n   .tag-chip__btn--dismiss       Error-red tinted variant.\n\n   Mobile: the action circles bump to var(--touch-target-min, 44px)\n   below 767px so finger taps reliably hit their target — previously\n   this rule lived in QueueWidget.css and only fired on the queue. */\n\n.tag-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 5px 3px 10px;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n/* .tag-chip--applied: shape only. The React caller supplies inline\n   `background`, `color`, and `borderColor` derived from the tag's own\n   color so each tag reads as its own thing. */\n.tag-chip--applied {\n  border-style: solid;\n}\n\n.tag-chip--suggested {\n  background: transparent;\n  color: #64748b;\n  border-style: dashed;\n  border-color: #94a3b8;\n}\n\n.tag-chip--proposed {\n  background: transparent;\n  color: #7c3aed;\n  border-style: dashed;\n  border-color: #a78bfa;\n}\n\n.tag-chip__prefix {\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  opacity: 0.7;\n}\n\n.tag-chip__remove {\n  border: none;\n  background: transparent;\n  color: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 0;\n  margin: 0 -2px 0 1px;\n  opacity: 0.5;\n  line-height: 1;\n}\n\n.tag-chip__remove:hover {\n  opacity: 1;\n}\n\n.tag-chip__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  line-height: 1;\n  border-radius: 50%;\n  transition:\n    background 0.15s ease,\n    box-shadow 0.12s ease;\n}\n\n.tag-chip__btn svg {\n  display: block;\n}\n\n.tag-chip__btn:focus-visible {\n  outline: 2px solid var(--color-info, #5c7cba);\n  outline-offset: 2px;\n}\n\n.tag-chip__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.tag-chip__btn--accept {\n  background: rgba(76, 106, 88, 0.15);\n  color: var(--color-secondary, #4c6a58);\n}\n\n.tag-chip__btn--accept:hover:not(:disabled) {\n  background: rgba(76, 106, 88, 0.28);\n}\n\n.tag-chip__btn--dismiss {\n  background: rgba(212, 76, 76, 0.12);\n  color: var(--color-error, #d44c4c);\n}\n\n.tag-chip__btn--dismiss:hover:not(:disabled) {\n  background: rgba(212, 76, 76, 0.22);\n}\n\n/* Mobile: the action circles get a proper touch target. 24px is fine\n   for a mouse pointer, well below the 44px minimum for a finger tap,\n   and accept/dismiss sit right next to each other so mis-taps happen\n   a lot. The chip padding + font size also nudge up so the wider\n   buttons don't push the label out. */\n@media (max-width: 767px) {\n  .tag-chip {\n    padding: 4px 6px 4px 12px;\n    gap: 8px;\n    font-size: 0.9rem;\n  }\n  .tag-chip__btn {\n    width: var(--touch-target-min, 44px);\n    height: var(--touch-target-min, 44px);\n  }\n  .tag-chip__btn svg {\n    width: 18px;\n    height: 18px;\n  }\n  /* Applied-tag remove × was tiny — users on mobile routinely\n     mis-tap it. Give it a real touch target. */\n  .tag-chip__remove {\n    min-width: 28px;\n    min-height: 28px;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
